export default __webpack_public_path__ + "static/media/google-2014.d7904ba6.svg";